module.exports = __webpack_public_path__ + "img/bannerBlue.a622e8e4.jpg";